'use strict';

var Backbone = require('dibs-backbone');
var _ = require('underscore');
var $ = require('dibs-jquery-shim');

var EmailView = module.exports = Backbone.BaseView.extend();

var mixins = require('../mixins/mixins');
var ModalEmailTracking = require('../tracking');
var MEC = require('../modalEmailConstants');
var InputView = require('./InputFieldView');
var serverVars = require('server-vars');
var formviewValidation = require('../../../models/formview-validation');
var SV = require('server-vars');
var Deferred = require('simply-deferred').Deferred;
var when = require('simply-deferred').when;

require('dibs-baseview-marinate');
require('bunsen/libraries/plugins/dibs-validation');

_.extend(EmailView.prototype, mixins, {

    el: '#modalOverlay-inner-content .email-form',
    subViewConfig : {
        inputField : {
            singleton: false,
            construct : InputView
        }
    },
    events : {
        'submit' : function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.send();
        }
    },
    viewEvents : {
        'validationCheck' : function () {
            this.$el.dibsValidation('validateForm');
        }
    },
    _getSendActions: function () {
        return [
            this._prepareToSend,
            this._saveUserNameIfNoneAssociated,
            this._postMessage
        ];
    },
    send: function () {
        return this._getSendActions().reduce(function (ready, action) {
            return when(ready).then(action.bind(this));
        }.bind(this), undefined).then(
            this._globalSuccess.bind(this),
            this._globalFailure.bind(this)
        );
    },
    initialize : function (options) {
        var validationCopy = SV.get('modalData.validationCopy');
        var ThisModalEmailTracking = ModalEmailTracking;

        this.options = options || {};
        if ('dealer' === this.model.get('type')) {
            ThisModalEmailTracking = ModalEmailTracking.Dealer;
        }
        this._tracking = new ThisModalEmailTracking({
            gaString: SV.get('modalData.gaString')
        });
        this.$body = $('body');
        this.subs.add('inputField', {
            el: '#from_name',
            value: this.model.getUserName(),
            validation: {
                regex_rules: { //eslint-disable-line camelcase
                    maxLength: MEC.EMAIL.FROM_NAME
                },
                messages: {
                    maxLength: 'must be under 50 characters'
                }
            }
        });
        this.subs.add('inputField', {
            el: '#from_email',
            value: this.model.getUserEmail(),
            validation : {
                required : true,
                regex_rules: { //eslint-disable-line camelcase
                    format: MEC.EMAIL.FORMAT,
                    maxLength: MEC.EMAIL.MAX_LENGTH
                },
                messages: {
                    format: validationCopy.emailMessage,
                    maxLength: 'must be under 100 characters'
                }
            }
        });
        this.subs.add('inputField', {
            el: '#message',
            validation : {
                regex_rules: { //eslint-disable-line camelcase
                    length: MEC.MSG_REGEX
                },
                messages: {
                    length: validationCopy.messageMessage,
                    default_message: validationCopy.requiredMessage //eslint-disable-line camelcase
                }
            }
        });
        this.$sendContainer = this.$('#sendButtonContainer').first();
        this.$sendButton = this.$sendContainer.find('#sendButton').first();
        this.$successMessage = this.$('.email-success-message').first();
        this.$successSubtext = this.$('.email-success-subtext').first();
        this.$serverErrorMsg = $('#serverError');

        this.focusOnFirstEmptyElm();
    },
    focusOnFirstEmptyElm: function () {
        var emptyFields = _.filter(this.$('#from_name, #from_email, #message'), function (elm) {
            return !elm.value;
        });
        if (this.model.get('isDesktop')) {
            _.result(emptyFields[0], 'focus');
        }
    },
    _prepareToSend : function () {
        var invalid;
        this.disable();
        this.$el.dibsValidation('validateForm');
        invalid = this.getClientErrors();
        // client-side validation failed
        if (invalid.length > 0) {
            this.enable();
            this._tracking.fireValidationGAEvent({
                errors: invalid,
                isClient: true
            });
            return false;
        }
        this.removeAllErrors();
    },
    _getFromName: function () {
        return this.$('#from_name').val();
    },
    _saveUserNameIfNoneAssociated: function () {
        var inputName = this._getFromName();
        var profile = this.model.get('user.profile');
        if (!profile) {
            return Deferred().resolve();
        }
        if (!inputName) {
            return undefined;
        }
        if (this.model.getUserName()) {
            return undefined;
        }
        return profile.setDisplayName(inputName).save();
    },
    _postMessage : function () {
        var msg = this.model.get('message');
        var itemId = typeof serverVars.data === 'object' ? serverVars.data.pk || serverVars.data.pageLabel || 'storefront' : 'null';
        this.populateMessage();
        // monkey-patch the item id to the URL so it shows in the access log (you can thank Vadim and Ross for this ;-| )
        return msg.save(null, { emulateJSON : true, queries: { itemId: itemId } })
            .then(
                function (data, status) {
                    var invalidInput;
                    var errors;
                    if (status !== 'success') {
                        return Deferred().reject();
                    }
                    if (_.result(data, 'success')) {
                        return undefined;
                    }
                    errors = data.errors || [];
                    if (0 === errors.length) {
                        return undefined; // TODO: figure out if this is an error or success scenario
                    }
                    _.each(errors, function (error) {
                        invalidInput = this.subs.findWhere({name: error.name});
                        if (invalidInput) {
                            formviewValidation.showValidationError(null, invalidInput.$el, { message: error.message });
                        }
                    }.bind(this));
                    this.enable();
                    this._tracking.fireValidationGAEvent({
                        errors: errors
                    });
                    return Deferred().reject({triggerBubble: 'userError'});
                }.bind(this));
    },
    _globalSuccess: function (options) {
        options = _.extend({
            triggerBubble: 'showSuccess'
        }, options);
        if (options.triggerBubble) {
            this.triggerBubble(options.triggerBubble);
        }
    },
    _globalFailure: function (options) {
        options = _.extend({
            triggerBubble: 'showServerError'
        }, options);
        if (options.triggerBubble) {
            this.triggerBubble(options.triggerBubble);
        }
    },
    populateMessage : function () {
        var msg = this.model.get('message');
        var emailDataMap = {};
        //hidden fields at the top level of the form element
        _.each(this.$el.serializeArray(), function (field) {
            emailDataMap[field.name] = $.trim(field.value);
        });
        //actual inputs which are down a level and thus unreachable by serializeArray?
        _.each(this.subs.getByType('inputField'), function (field) {
            emailDataMap[field.name] = field.getValue();
        });

        emailDataMap.subject = msg.get('subject');
        msg.set('emailDataMap', emailDataMap);
        return msg;
    },
    enable : function () {
        this.$sendButton.prop('disabled', false);
        this.$sendButton.removeClass('is-disabled');
        this.triggerDescend('enableInputs');
    },
    disable : function () {
        this.$sendButton.prop('disabled', true);
        this.$sendButton.addClass('is-disabled');
        this.triggerDescend('disableInputs');
    },
    initValidation : function () {
        this.$el.dibsValidation(this.getValidationRules(), {
            isEnableScroll: false,
            validateOnChange: false
        }).on('formError', formviewValidation.showValidationError)
            .on('formErrorResolved', formviewValidation.hideValidationError);
    },
    getValidationRules : function () {
        return _.chain(this.subs.get('inputField')).map(function (inputField) {
            return [inputField.name, inputField.validation];
        }).object().value();
    },
    getClientErrors : function () {
        return _.chain(this.subs.get('inputField')).map(function (view) {
            var $error = view.$el.siblings('.err-message.active');
            if ($error.length) {
                return {
                    name: view.name,
                    message: $error.text()
                };
            }
        }).compact().value();
    },
    removeAllErrors : function () {
        _.each(this.subs.get('inputField'), function (view) {
            formviewValidation.hideValidationError(null, view.$el);
        });
        this.subs.descend('removeAllErrors');
    }

});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/modalEmail/views/EmailView.js
// module id = 1190
// module chunks = 4 7 12